import {
    Text,
    Box,
    Stack,
    Avatar,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    SimpleGrid,
    Grid,
    GridItem,
    Flex
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoNote } from "react-icons/go";

export function ClientCard({ data = null, deleteFn, editFn, showOptions, showReportBtn, showReportModal }) {
    const toTitleCase = (s) => {
        return s.toLowerCase().split(' ').map(w =>
            w.charAt(0).toUpperCase() + w.slice(1)
        ).join(' ');
    }

    const deleteClient = () => {
        deleteFn(data.agentId);
    }

    const editClient = () => {
        editFn(data);
    }

    return (
        <>
            <Card>
                <Grid gridTemplateColumns={'90% 10%'} gap='6%'>
                    <GridItem>
                        <Stack direction={'row'} spacing={4}>
                            <Box ml={'-4px'} pt={1}>
                                <Avatar name={data.agentName} bg='#16456d' color={'white'}></Avatar>
                            </Box>
                            <Grid>
                                <GridItem><Text w={showOptions ? { base: '180px', '2xl': '270px', '3xl': '350px' } : { base: '200px', '2xl': '270px', '3xl': '350px' }} fontSize={'16px'} fontWeight={600} color={'gray.700'}>{toTitleCase(data.agentName)}</Text></GridItem>
                                <GridItem>
                                    <Text w={showOptions ? { base: '190px', '2xl': '270px', '3xl': '350px' } : { base: '210px', '2xl': '270px', '3xl': '350px' }} fontSize={'12px'} color={'gray.600'}>{data.email}</Text>
                                </GridItem>
                            </Grid>
                        </Stack>
                    </GridItem>
                    <GridItem pt={4}>
                        {showOptions &&
                            <Menu>
                                <MenuButton><BsThreeDotsVertical size={'18px'} color={'gray'} /></MenuButton>
                                <MenuList>
                                    <MenuItem color={'#0C7FE9'} _hover={{
                                        bgColor: '#f0f7fd'
                                    }} onClick={editClient}>Edit</MenuItem>
                                    <MenuItem color={'#cc0000'} _hover={{
                                        bgColor: '#f0f7fd'
                                    }} onClick={deleteClient}>Delete</MenuItem>
                                </MenuList>
                            </Menu>}
                    </GridItem>
                </Grid>
                {showReportBtn && <Stack pt={3}>
                    <Button
                        fontSize={{ base: "12px", md: "15px" }}
                        colorScheme='blue'
                        variant='outline'
                        leftIcon={<GoNote size={"22px"} />}
                        onClick={() => showReportModal({ agentId: data.agentId, agentName: toTitleCase(data.agentName) })}
                    >
                        Generate Report
                    </Button>
                </Stack>}
            </Card>
        </>
    )
}